import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import log from '../../utils/logger';
import { useNavigate } from 'react-router-dom';
import { useSignupInvite } from '../../contexts/buyer-invite';

const ReceiveInvite = () => {
  const navigate = useNavigate();
  const { setPrefillData } = useSignupInvite();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setPrefillData(decoded);
      } catch (err) {
        log.error(err);
      }
    }
    navigate('/home');
  }, []);

  return (
    <div>Redirecting to home...</div>
  );
};

export default ReceiveInvite;
